import { useRef, useState } from "react";
import { Upload, Trash2 } from "lucide-react";

export default function SignaturePad({ storageKey = "nawadah_signature" }) {
  const canvasRef = useRef(null);
  const fileRef = useRef(null);
  const drawing = useRef(false);
  const [sig, setSig] = useState(() => localStorage.getItem(storageKey) || "");

  const save = (dataUrl) => {
    setSig(dataUrl);
    localStorage.setItem(storageKey, dataUrl);
  };

  const clear = () => {
    setSig("");
    localStorage.removeItem(storageKey);
    const c = canvasRef.current;
    if (c) c.getContext("2d").clearRect(0, 0, c.width, c.height);
  };

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - r.left, y: t.clientY - r.top };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0B1F3A";
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    save(canvasRef.current.toDataURL("image/png"));
  };

  const onUpload = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const rd = new FileReader();
    rd.onload = () => save(rd.result);
    rd.readAsDataURL(f);
    e.target.value = "";
  };

  return (
    <div className="inline-block" data-testid={`signature-pad-${storageKey}`}>
      {sig ? (
        <img src={sig} alt="Tanda tangan" className="h-16 mx-auto object-contain" data-testid={`signature-image-${storageKey}`} />
      ) : (
        <div className="h-16" />
      )}
      <div className="no-print mt-2 flex flex-col items-center gap-2">
        <canvas
          ref={canvasRef}
          width={240}
          height={80}
          className="border border-dashed border-slate-300 rounded bg-white touch-none cursor-crosshair"
          onMouseDown={start}
          onMouseMove={move}
          onMouseUp={end}
          onMouseLeave={end}
          onTouchStart={start}
          onTouchMove={move}
          onTouchEnd={end}
          data-testid={`signature-canvas-${storageKey}`}
        />
        <p className="text-[10px] text-slate-400">Tanda tangan langsung di kotak, atau upload gambar tanda tangan</p>
        <div className="flex gap-2">
          <button type="button" onClick={() => fileRef.current.click()} data-testid={`signature-upload-${storageKey}`} className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-slate-300 text-xs font-bold rounded-md hover:bg-slate-50 transition-colors">
            <Upload className="h-3.5 w-3.5" /> Upload Gambar
          </button>
          <button type="button" onClick={clear} data-testid={`signature-clear-${storageKey}`} className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-red-300 text-red-600 text-xs font-bold rounded-md hover:bg-red-50 transition-colors">
            <Trash2 className="h-3.5 w-3.5" /> Hapus
          </button>
        </div>
        <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={onUpload} data-testid={`signature-file-${storageKey}`} />
      </div>
    </div>
  );
}
